/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ScoreThresholdTransitionOperator } from "./ScoreThresholdTransitionOperator";

export interface ScoreThresholdTransition {
  type: "score_threshold";
  score_id: string;
  operator: ScoreThresholdTransitionOperator;
  value: number;
  next_stage: string;
  otherwise: "complete" | string;
}
